<template>
  <div class="d-flex w-100 flex-column">
    <v-card v-for="comment in comments" :key="comment.id" class="w-100 mb-10">
      <v-card-text>
        <div>
          <v-avatar class="mr-3">
            <v-img
              :data-testid="`jira-comment-${comment.id}-avatar`"
              :src="comment.author.avatarUrls['32x32']"
              :alt="comment.author.displayName"
            />
          </v-avatar>
          <span
            :data-testid="`jira-comment-${comment.id}-author`"
            class="text-body-2"
            >{{ comment.author.displayName }}</span
          >
          <hr class="mt-3 mb-3" />

          <div
            v-for="(content, index) in comment.body.content"
            :key="content.type + index"
          >
            <JiraCommentBlock
              :data-testid="`jira-comment-${comment.id}-block`"
              :type="content.type as CommentContentType"
            >
              <span v-for="(contentWithin, i) in content.content" :key="i">
                <JiraCommentContent
                  :id="i"
                  :data-testid="`jira-comment-${comment.id}-content`"
                  :type="contentWithin.type as ContentType"
                  :attrs="contentWithin.attrs"
                  :content="contentWithin"
                />
              </span>
            </JiraCommentBlock>
          </div>

          <hr class="mt-3 mb-3" />
          <div
            :data-testid="`jira-comment-${comment.id}-created`"
            class="text-body-2"
          >
            {{ dayjs(comment.created).format("ddd, D MMM YY h:mm A") }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import {
    CommentContentType,
    CommentType,
    ContentType,
  } from "@/models/jiraIssue/jiraIssue.types"
  import dayjs from "dayjs"
  import JiraCommentBlock from "@/views/customer/issues/components/JiraCommentBlock.vue"
  import JiraCommentContent from "@/views/customer/issues/components/JiraCommentContent.vue"

  export default defineComponent({
    components: { JiraCommentContent, JiraCommentBlock },
    props: {
      comments: {
        type: Array as PropType<CommentType[]>,
        default: [] as CommentType[],
        required: true,
      },
    },
    computed: {
      CommentContentType() {
        return CommentContentType
      },
      ContentType() {
        return ContentType
      },
    },
    methods: { dayjs },
  })
</script>
